
import EmojiNormal from "../../../assets/filled/EmojiNormal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmojiNormalIcon({ className, dataTestid = "EmojiNormalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EmojiNormal data-testid={dataTestid} className={classes} {...rest} />
  );
}
